"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function YourTailoredRecruitmentSolutions() {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.opacity = "1";
    }
  }, []);
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return <section className="relative w-full h-screen overflow-hidden bg-gradient-to-br from-primary via-primary-dark to-secondary" onMouseLeave={handleMouseLeave}>
      <div className="absolute inset-0 surface-overlay" />

      <div className="relative z-10 flex items-center justify-center h-full px-4">
        <div ref={contentRef} className="max-w-3xl w-full p-12 md:p-16 opacity-0 transition-opacity duration-[var(--duration-slow)] ease-[var(--ease-smooth)] relative bg-background rounded-lg shadow-medium" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground mb-6 leading-tight">Great Care Begins With Great People.</h1>

          <p className="text-lg md:text-xl text-foreground mb-8 leading-relaxed">Your trusted solution for exceptional leadership and management talent.</p>

          <div className="flex items-center justify-center">
            <Link to="/ContactUsPage">
              <Button className="btn-primary px-6 py-3 font-semibold focus-ring relative overflow-hidden group">
                <span className="relative z-10 flex items-center gap-2">
                  Get Started
                  <ArrowRight className="size-5 group-hover:translate-x-1 transition-transform duration-[var(--duration-medium)]" />
                </span>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}